import { generateUuid } from '@aims/shared/shared/utils';
import { gql, useMutation } from '@apollo/client';
import { Form, Modal, notification } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import EditTransferFormItems from './components/EditTransferFormItems';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

export const updateTransferMutation = gql`
  mutation UpdateTransfer($transfer: TransferUpdateInput!) {
    updateTransfer(transfer: $transfer) {
      transfer {
        _id
      }
    }
  }
`;

const TransferUpdateModal = ({ visible, onFinish, onCancel }) => {
  const { transfer } = visible || {};
  const [saving, setSaving] = useState(false);
  const [updateTransfer] = useMutation(updateTransferMutation);

  const onSubmit = useCallback(
    async (_values) => {
      setSaving(true);
      try {
        const { ...values } = _values;
        await updateTransfer({
          variables: {
            transfer: {
              _id: transfer._id,
              ...values,
            },
          },
        });
        notification.success({
          message: 'Saved',
          description: 'Transaction updated successfully',
        });
        if (onFinish) {
          onFinish();
        }
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description: 'We apologize.  An error occurred',
        });
      }
      setSaving(false);
    },
    [updateTransfer, onFinish, transfer],
  );

  const [form] = Form.useForm();
  useEffect(() => {
    if (transfer) {
      form.setFieldsValue({ ...transfer });
    } else {
      form.resetFields();
    }
  }, [form, transfer]);

  return (
    <Modal
      header={null}
      open={!!visible}
      closable={!saving}
      destroyOnClose={true}
      maskClosable={true}
      onCancel={oncancel}
      footer={null}
    >
      <TaskSomethingForm
        title="Update Transfer"
        form={form}
        onFinish={onSubmit}
        onCancel={onCancel}
        saving={saving}
      >
        <EditTransferFormItems />
      </TaskSomethingForm>
    </Modal>
  );
};

export default TransferUpdateModal;
